/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 13:00:13
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-17 11:31:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/slice/constants.ts
 */
export enum EnumReducers {
  customization = 'customization',
  productContent = 'productContent',
  productAliasEdit = 'productAliasEdit',
  productAlias = 'productAlias',
  productEdit = 'productEdit',
}
